import React from "react";
// import L from "leaflet";
import PropTypes from "prop-types";
import SweetAlert from "react-bootstrap-sweetalert";
import CustomInput from "components/CustomInput/CustomInput.js";
import StarsRating from "components/RestaurantDetails/StarsRating.js";
import addReview from "api/review/addReview.js";

export default function WriteReview(props) {
  const [menuScore, setMenuScore] = React.useState(0);
  const [locationScore, setLocationScore] = React.useState(0);
  const [serviceScore, setServiceScore] = React.useState(0);
  const [price, setPrice] = React.useState("");
  const [description, setDescription] = React.useState("");
  const restaurant = props.restaurant;
  const user = props.user;

  return (
    <div className="popup_evaluation_restaurant">
      {/* <SweetAlert
        title={"Recensisci " + restaurant.name}
        onConfirm={() => {
          const menu = Number(menuScore) * 2;
          const location = Number(locationScore) * 2;
          const service = Number(serviceScore) * 2;

          const review = {
            text: description,
            price,
            menu,
            location,
            service,
            total: (Number(menu) + Number(location) + Number(service)) / 3,
            restaurantId: restaurant._id
          };
          addReview(review)
            .then(res => {
              console.log("res", res);
              const rest = Object.assign({}, restaurant);
              rest.reviews.push(res.review);
              rest.pescatoriScoreService = res.scoreService;
              rest.pescatoriScorePlace = res.scorePlace;
              rest.pescatoriScoreFood = res.scoreFood;
              rest.pescatoriScoreOverall = res.scoreOverall;
              rest.pescatoriPrice = res.price;

              props.setRestaurant(rest);
              props.hideAlert(false);
            })
            .catch(err => {
              console.log("err", err);
              props.hideAlert(false);
            });
        }}
        onCancel={() => props.hideAlert(false)}
        confirmBtnCssClass={"show-more-results reverse-color"}
      > */}
      <div style={{ width: "100%", display: "flex" }}>
        <label className="stars_rating_label">Voto Menu: </label>
        <StarsRating setScore={setMenuScore} type="menu" />
      </div>
      <div style={{ width: "100%", display: "flex" }}>
        <label className="stars_rating_label">Voto Location: </label>
        <StarsRating setScore={setLocationScore} type="location" />
      </div>
      <div style={{ width: "100%", display: "flex" }}>
        <label className="stars_rating_label">Voto Servizio: </label>
        <StarsRating setScore={setServiceScore} type="service" />
      </div>
      <CustomInput
        formControlProps={{ fullWidth: true }}
        labelText={"Prezzo"}
        inputProps={{
          value: price,
          onChange: e => {
            setPrice(e.target.value);
          }
        }}
      />
      <CustomInput
        formControlProps={{ fullWidth: true }}
        labelText={"Descrizione"}
        inputProps={{
          value: description,
          multiline: true,
          rows: 3,
          onChange: e => {
            setDescription(e.target.value);
          }
        }}
      />
      <div className="reservation-button-container">
        <div style={{ display: "flex" }}>
          <button
            // type="submit"
            onClick={() => {
              if (!menuScore) {
                alert("devi inserire una valutazione al menu per recensire");
              } else if (!locationScore) {
                alert(
                  "devi inserire una valutazione alla location per recensire"
                );
              } else if (!serviceScore) {
                alert(
                  "devi inserire una valutazione al servizio per recensire"
                );
              } else if (!price) {
                alert("devi inserire il prezzo per recensire");
              } else {
                const menu = Number(menuScore) * 2;
                const location = Number(locationScore) * 2;
                const service = Number(serviceScore) * 2;
                const total =
                  (Number(menu) + Number(location) + Number(service)) / 3;
                const score = [
                  { name: "menu", score: menu },
                  { name: "location", score: location },
                  { name: "service", score: service },
                  { name: "total", score: total }
                ];
                const review = {
                  blob: description,
                  price,
                  checkInId: props.checkInId,
                  menu,
                  restaurantName: props.restaurantName,
                  location,
                  service,
                  score,
                  total,
                  restaurantId: props.restaurant
                };
                console.log(review, props);
                addReview(review)
                  .then(res => {
                    console.log("res", res);
                    // const rest = Object.assign({}, restaurant);
                    // rest.reviews.push(res.review);
                    // rest.pescatoriScoreService = res.scoreService;
                    // rest.pescatoriScorePlace = res.scorePlace;
                    // rest.pescatoriScoreFood = res.scoreFood;
                    // rest.pescatoriScoreOverall = res.scoreOverall;
                    // rest.pescatoriPrice = res.price;

                    props.setReview({
                      score,
                      total,
                      price
                    });
                    // props.hideAlert(false);
                  })
                  .catch(err => {
                    console.log("err", err);
                    props.hideAlert(false);
                  });
              }
            }}
            className="reservation-button"
            // disabled={!canSubmit}
          >
            Recensisci
          </button>
        </div>
      </div>
    </div>
  );
}

WriteReview.propTypes = {
  restaurantId: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  hideAlert: PropTypes.func.isRequired,
  setRestaurant: PropTypes.func.isRequired
};
